<div class="c-multiGameChallengesReward">
  <div class="c-multiGameChallengesReward__container">
    <div
      class="c-multiGameChallengesReward__background"
      theming
      [themingGroup]="isAdventureQuest ? 'adventurequest' : 'gamechallenges'"
      themingAsset="start-background"
      [themingOverride]="multiGameChallengesRewardModalData?.properties?.assets">
      <div class="c-multiGameChallengesReward__info">
        <div
          class="c-multiGameChallengesReward__icon"
          theming
          [themingGroup]="isAdventureQuest ? 'adventurequest' : 'gamechallenges'"
          themingAsset="logo"
          [themingOverride]="multiGameChallengesRewardModalData?.properties?.assets"></div>

        <div class="c-multiGameChallengesReward__text">
          <span class="text title">
            {{
              isAdventureQuest
                ? ('home.live-ops.adventure-quest.modal-reward.title' | translate | uppercase)
                : ('home.live-ops.multichallenges.modal-reward.title' | translate | uppercase)
            }}
          </span>
          <span class="text subtitle">
            {{
              isAdventureQuest
                ? ('home.live-ops.adventure-quest.modal-reward.subtitle' | translate)
                : ('home.live-ops.multichallenges.modal-reward.subtitle' | translate | uppercase)
            }}
          </span>
        </div>

        <div
          class="c-multiGameChallengesReward__box"
          theming
          [themingGroup]="isAdventureQuest ? 'adventurequest' : 'gamechallenges'"
          themingAsset="reward-box"
          [themingOverride]="multiGameChallengesRewardModalData?.properties?.assets">
          <slotcom-display [classes]="['c-display--large c-display--large--reward']">
            <div
              displayIcon
              displayIconPos="left"
              class="c-display--coin"></div>
            <span
              class="text"
              [ngStyle]="{ 'font-size': setFontSize() }"
              >{{
                multiGameChallengesRewardModalData.reward.credits | number: '1.0-0' : ('common.culture' | translate)
              }}</span
            >
          </slotcom-display>
        </div>
      </div>

      <slotcom-button
        class="c-button--pink"
        (safeClick)="closeModal()"
        audioType="reward">
        {{
          multiGameChallengesRewardModalData.properties.buttonText[lang]
            ? multiGameChallengesRewardModalData.properties.buttonText[lang]
            : ('home.buttons.collect' | translate | uppercase)
        }}
      </slotcom-button>
    </div>
  </div>
</div>
